export default {
    SET_MODAL_CONNECT_WITH_DATA: 'setModalConnectWithData',
    SET_MODAL_CONNECT_WITH_OPTIONS: 'setModalConnectWithOptions',
    SET_ITEM_ALLOCATION: 'setItemAllocation',
    SET_MODAL_CONNECT_WITH_ERRORS: 'setModalConnectErrors',
    SET_MODAL_CONNECT_WITH_DATE: 'setConnectWithDate',
    SET_MODAL_CONNECT_WITH_DESCRIPTION: 'setModalConnectWithDescription',
    SET_MODAL_CONNECT_WITH_CURRENCY_EXCHANGE: 'setModalConnectWithCurrencyExchange',
    ADD_UNALLOCATED_PAYMENT_TO_MODAL_DATA: 'addUnallocatedPaymentToModalData',
    REMOVE_UNALLOCATED_PAYMENT_FROM_MODAL_DATA: 'removeUnallocatedPaymentFromModalData'
}